import { CURRENCY_CODE } from "@/lib/constant";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackCouponApplied = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackCouponAppliedEvent = useCallback(
    (cartData, couponName) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (cartData && couponName) {
          const { total, shippingCharges, tax, subTotal, couponDiscount } =
            cartData;
          const eventData = {
            total,
            couponName,
            shippingCharges,
            discount: couponDiscount,
            currency: CURRENCY_CODE,
            tax,
            subTotal,
          };

          window.webengage.track("coupon_applied", eventData);
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackCouponAppliedEvent };
};

export default useTrackCouponApplied;
